"use client";
import { type Resource, createInstance } from "i18next";
import ICU from "i18next-icu";
import type React from "react";
import { useState } from "react";
import { I18nextProvider, initReactI18next } from "react-i18next";

import { defaultNS, getOptions } from "../settings";

// Resources are loaded on the server and passed in, so i18next can initialise
// synchronously and the page renders on the server instead of after hydration.
function initTranslations(lng: string, resources: Resource) {
  const i18n = createInstance();
  i18n
    .use(initReactI18next)
    .use(ICU)
    .init({
      ...getOptions(lng),
      ns: Object.keys(resources[lng] ?? resources.en ?? {}),
      resources,
      initAsync: false,
    });

  return i18n;
}

export function I18nProvider({
  locale,
  resources,
  children,
}: {
  locale: string;
  resources: Resource;
  children: React.ReactNode;
}) {
  const [i18n] = useState(() => initTranslations(locale, resources));

  return (
    <I18nextProvider i18n={i18n} defaultNS={defaultNS}>
      {children}
    </I18nextProvider>
  );
}
